<template>
  <Form
    ref="form"
    v-slot="{ errors, isSubmitting }"
    :initial-values="initialValues"
    :validation-schema="validationSchema"
    @submit="submit"
  >
    <FieldInput
      :disabled="isSubmitting"
      :error="errors.date"
      name="date"
      type="date"
    />

    <FieldInput
      :disabled="isSubmitting"
      :error="errors.amount"
      name="amount"
      type="number"
    />

    <FieldSelect :disabled="isSubmitting" :error="errors.source" name="source">
      <option value="">Select</option>
      <option v-for="(source, idx) in incomeSources" :key="idx" :value="source">
        {{ source }}
      </option>
    </FieldSelect>

    <FieldTextarea
      :disabled="isSubmitting"
      :error="errors.description"
      name="description"
    />

    <div class="field is-grouped">
      <div class="control">
        <button
          :class="{ 'is-loading': isSubmitting }"
          :disabled="isSubmitting"
          class="button is-link"
        >
          Add
        </button>
      </div>
    </div>
  </Form>
</template>

<script>
import { number, object, string } from 'yup';
import { Form } from 'vee-validate';
import { createNamespacedHelpers } from 'vuex';
import { dateToISOStringWithoutTimezone } from '@/utils';
import FieldInput from './FieldInput.vue';
import FieldSelect from './FieldSelect.vue';
import FieldTextarea from './FieldTextarea.vue';

const { mapActions, mapState } = createNamespacedHelpers('balanceSheet');

export default {
  components: {
    FieldInput,
    FieldSelect,
    FieldTextarea,
    Form,
  },

  setup() {
    return {
      initialValues: {
        date: dateToISOStringWithoutTimezone(new Date()),
        source: '',
      },
      validationSchema: object().shape({
        date: string().required(),
        amount: number()
          .required()
          .positive(),
        source: string().required(),
      }),
    };
  },

  computed: {
    ...mapState(['incomeSources']),
  },

  methods: {
    ...mapActions(['addIncome']),

    async submit(values, { resetForm }) {
      try {
        await this.addIncome(values);

        resetForm();

        window.alert('Your record is added.');
      } catch (error) {
        window.alert(`Failed to add the record (${error.message}).`);
      }
    },
  },
};
</script>
